export const cantons = [
  "Aargau",
  "Appenzell Ausserrhoden",
  "Appenzell Innerrhoden",
  "Basel-Landschaft",
  "Basel-Stadt",
  "Bern/Berne",
  "Fribourg/Freiburg",
  "Genève",
  "Glarus",
  "Graubünden",
  "Jura",
  "Luzern",
  "Neuchâtel",
  "Nidwalden",
  "Obwalden",
  "Schaffhausen",
  "Schwyz",
  "Solothurn",
  "St. Gallen",
  "Ticino",
  "Thurgau",
  "Uri",
  "Vaud",
  "Valais/Wallis",
  "Zug",
  "Zürich"
];
